import React, { useContext, useState } from 'react'
import Modal from '../../../../common/modal/Modal'
import Button from '../../../../common/button/Button'
import ResponseMessage from "../../../../common/modal/ResponseMessage";
import useMemberTable from '../context/MemberTableContext';
import { formRequest } from '../form/Utils';
import { HandleShowCloseModal } from '../../../../common/modal/HandleShowCloseModal';
import Icons from '../../../../common/icons/Icons';
import { modalConfirmationMessageId, modalMembersTblBtnId } from './Utils';
import { modalPendingInviteTblBtnId } from '../PendingInvites/Utils';

const ModalConfirmation = () => {

  const { selectedUser, selectedModal, refetchMembers, refetchPendingInvites } = useMemberTable()
  const [ responseMessage, setResponseMessage ] = useState('')

  const membersConfirmation = Object.values(modalMembersTblBtnId).map(item => item.request) ?? []
  const pendingInvitesConfirmation = Object.values(modalPendingInviteTblBtnId).map(item => item.request) ?? []
  const hasRefetch =  membersConfirmation.includes( selectedUser.modal?.request ) ? refetchMembers 
                    : pendingInvitesConfirmation.includes( selectedUser.modal?.request ) ? refetchPendingInvites : null

  const formData = new FormData()
  formData.append('action', selectedUser.modal?.request)

  if( selectedUser && membersConfirmation.includes( selectedUser.modal?.request ) ){

    const role =  selectedUser.modal?.request === 'msync_member_set_as_manager' ? 'manager' 
                : selectedUser.modal?.request === 'msync_member_set_as_member' ? 'member' 
                : selectedUser.role
    formData.append('team_id', selectedUser.teamId)
    formData.append('team_type', selectedUser.teamType)
    formData.append('member_id', selectedUser.userId)
    formData.append('role',  role)
    formData.append('nonce', group_dashboard.nonce_members)

  }else if( selectedUser && pendingInvitesConfirmation.includes( selectedUser.modal?.request ) ){

    let wpNonce = ''
    switch (selectedUser.modal?.action) {
      case 'invitation_set_as_manager':
        wpNonce = selectedUser.invitationWpNonce?.invitationSetAsManager 
        break;
      case 'invitation_set_as_member':
        wpNonce = selectedUser.invitationWpNonce?.invitationSetAsMember
        break;
      case 'invitation_resend':
        wpNonce = selectedUser.invitationWpNonce?.invitationResend
        break;
      case 'invitation_revoke':
        wpNonce = selectedUser.invitationWpNonce?.invitationRevoke
        break;
    }

    formData.append('invitation_team_id', selectedUser.invitationTeamId)
    formData.append('invitation_id', selectedUser.invitationId)
    formData.append('invitation_action', selectedUser.modal?.action)
    formData.append('invitation_wpnonce', wpNonce)

  }

  const { isLoading, isFetching, isError, error, refetch, data } = formRequest( formData, setResponseMessage, hasRefetch )

  const handleBackToSelectedModal = () => {
    HandleShowCloseModal( selectedModal, modalConfirmationMessageId )
  }

  return (
    <Modal 
      modalId={ modalConfirmationMessageId } 
      showModalHeader={ false }
      buttonTitle={''}
      modalClassNames={'msync-members-custom-modal'}
      >
        
      <header className="msync-modal__header">
        <div className="msync-modal__header__title">
          {
            selectedModal &&
            <button onClick={ () => handleBackToSelectedModal() }>
              <Icons type="arrow-tail-left" />
            </button>
          }
          <h2 className="msync-modal__header__title__text msync-modal__title">{ selectedUser.modal?.title }</h2>
        </div>

        <Button 
          className="msync-modal__close" 
          aria-label="Close modal" 
          onClick={()=>MicroModal.close( modalConfirmationMessageId )}
        >
          <Icons type='close' />
          <span className="msync-visually-hidden">Close <kbd>ESC</kbd></span>
        </Button>
      </header>
      { 
        isError
        ? <ResponseMessage response={{
            type: 'error',
            message: error.message
          }} />
        : responseMessage && (
        <ResponseMessage response={{
          type: data ? 'success' : 'error',
          message: responseMessage
        }} /> )
      }
      <main className="msync-modal__body">
        <p>
          {
            selectedUser.modal?.content
            ? selectedUser.modal?.content
            : ''
          }
        </p>
      </main>
      <footer className='msync-modal__footer'>
        <Button
          className="msync-button--is-style-outline msync-button--is-theme-destructive"
          type="button"
          name="Cancel"
          onClick={()=>MicroModal.close(modalConfirmationMessageId)}
          aria-label="Close this dialog window"
        />
        <Button
          onClick={ () => refetch() }
          name={ isLoading || isFetching ? 'Loading...' : 'Confirm' }
          disabled={ isLoading || isFetching ? true : false }
        />
      </footer>
    </Modal>
  )
}

export default ModalConfirmation
